import uuid from 'uuid-random';
import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

import { ChangeLimitPopup } from '../ChangeLimitPopup';

const popupId = uuid();

export const showChangeLimitPopupAction = (data = {}) => addPopupAction({
    id: popupId,
    layer: LAYER.ADVANCED_PLAYER_MESSAGE,
    addFirst: true,
    title: 'playtech.mobile.responsiblegaminglosslimits.popup.title',
    className: 'choose-limits-popup',
    component: ChangeLimitPopup,
    ...data
});
